import { queryClient } from "@/queryClient"
import type { MerchantCurrencyCode } from "@/utils/currency"

export type CreateUpdateMerchantGroupRequest = {
  name: string
  merchantIds: Array<number>
  adminEmails: Array<string>
}

type CreateUpdateMerchantGroupResponse = {
  id: string
  name: string
  merchants: Array<{
    id: number
    name: string
    mid: string | null
    currency: MerchantCurrencyCode
  }>
  admins: Array<{
    email: string
  }>
}

export const updateMerchantGroup = async (
  merchantGroupId: string,
  params: CreateUpdateMerchantGroupRequest
) => {
  const response =
    await api.put<CreateUpdateMerchantGroupResponse>(
      `/merchant-groups/${merchantGroupId}`,
      {
        body: params,
      }
    )

  queryClient.invalidateQueries({
    queryKey: [MERCHANTS_QUERY_KEY],
  })
  queryClient.invalidateQueries({
    queryKey: [MERCHANT_GROUPS_QUERY_KEY],
  })

  return response.body
}

export const createMerchantGroup = async (
  params: CreateUpdateMerchantGroupRequest
) => {
  const response =
    await api.post<CreateUpdateMerchantGroupResponse>(
      "/merchant-groups/",
      {
        body: params,
      }
    )

  queryClient.invalidateQueries({
    queryKey: [MERCHANTS_QUERY_KEY],
  })
  queryClient.invalidateQueries({
    queryKey: [MERCHANT_GROUPS_QUERY_KEY],
  })

  return response.body
}
